import { ICD10Disease, ICD10DiseaseQuery } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import {
   AutosuggestItemRenderer,
   AutosuggestSearchCreator,
   StrongText,
   Text,
   TextSeparator,
   TextSeparatorType,
} from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

export const searchCreator = (dictionaryValidOn: Date): AutosuggestSearchCreator<ICD10Disease> => {
   return (searchText) => {
      return async () => {
         return performCqrsQuerySearch<ICD10Disease>(() => {
            const query = new ICD10DiseaseQuery();
            query.codeOrName = TextPattern.anywhereIgnoreCase(searchText ?? undefined);
            query.dictionaryValidOn = dictionaryValidOn;
            return query;
         });
      };
   };
};

export const itemRenderer: AutosuggestItemRenderer<ICD10Disease> = (item) => {
   return (
      <TextSeparator separator={TextSeparatorType.SPACE}>
         <StrongText testId={'name'}>{item.name}</StrongText>
         <Text testId={'code'}>{`(${item.code})`}</Text>
      </TextSeparator>
   );
};

export const diseaseLabelExtractor = ({ name }: ICD10Disease): string => name;
